<div class="relative h-[227px] w-[384px] sm:h-[275px] sm:w-[1306px] overflow-hidden rounded-[36.36px] sm:rounded-[50px]">
  <!-- If you can pass a class to the internal <img>, do this: -->
  <ln-ln-image-frame
    [src]="imageUrl"
    alt="Imagen del producto"
    [class]="'block w-full h-full object-cover object-top'"
    width="165"
    height="165"
  ></ln-ln-image-frame>
  <div class="absolute top-[62px] left-[21px] sm:top-[74px] sm:left-[53px]">
    <div class="w-[211px] h-[69px] sm:w-[515px] sm:h-[92px] text-blanco text-xl font-medium sm:text-4xl leading-[1.25rem] sm:font-normal">
      {{'hero.contact.title' | transloco}}
    </div>
    <div class="w-[217px] h-[19px] sm:w-[341px] sm:h-[49px] mt-[16px] justify-start text-blanco text-sm sm:text-2xl font-bold font-['Roboto']">{{'hero.contact.subTitle' | transloco}}</div>

  </div>
</div>
